/**
 * Footer.vue
 * The main footer component that organizes and displays all footer sections.
 * Features:
 * - Asynchronously loads footer sections (Info, About, Brand)
 * - Grid-based layout for responsive design
 * - Event handling for news count reset
 * - Modular structure with separate components
 */
<template>
  <footer class="hkpn-footer ds-container">
    <Info
      class=" ds-grid ds-p"
      @reset-news-count="emit('reset-news-count')"
    />
    <About class=" ds-grid ds-p" />
    <Brand class=" ds-grid ds-p" />
  </footer>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'FooterComponent'
}
</script>

<script setup>
/**
 * Component setup section
 * Manages footer section components and event handling
 */

// Emits event to reset news count
const emit = defineEmits(['reset-news-count'])

// Asynchronously load footer section components
const Info = defineAsyncComponent(() => import('@/components/shared/footer/Info.vue'))
const About = defineAsyncComponent(() => import('@/components/shared/footer/About.vue'))
const Brand = defineAsyncComponent(() => import('@/components/shared/footer/Brand.vue'))
</script>
